import { useMemo } from "react"
import { DashboardPaper } from "../Dashboard/Old/Atom"

type navigationProps = {
  data: {
    label: string
    value: any
  }[]
}

export const NavigationAssistant = ({ data }: navigationProps) => {
  const message = useMemo(() => {
    let message = "Select filters"
    for (let item of data) {
      if (!item.value) {
        return item.label
      }
    }
    return message
  }, [data])

  return (
    <DashboardPaper
      sx={{ mb: "10px", justifyContent: "center", alignItems: "center" }}
    >
      {message}
    </DashboardPaper>
  )
}
